
(function () {
  if (window.cardQuantityInitialized) return;
  window.cardQuantityInitialized = true;

  function updateQuantity(input, direction) {
    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const max = input.max !== '' ? Number(input.max) : Infinity;
    const current = Number(input.value) || min;

    let next;

    if (direction === 'increase') {
      next = current + step;
    } else {
      next = current - step;
    }

    next = Math.max(min, Math.min(max, next));

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-quantity-action]');
    if (!button) return;

    const wrapper = button.closest('.card-quantity-selector');
    if (!wrapper) return;

    const input = wrapper.querySelector('.card-quantity-input');
    if (!input) return;

    updateQuantity(input, button.dataset.quantityAction);
  });

  document.addEventListener('change', function (event) {
    const input = event.target;

    if (!input.matches('.card-quantity-input')) return;

    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const max = input.max !== '' ? Number(input.max) : Infinity;

    let value = Number(input.value);

    if (!Number.isFinite(value)) value = min;

    value = Math.max(min, Math.min(max, value));

    // Keep the entered quantity aligned with the allowed increment.
    value = min + Math.ceil((value - min) / step) * step;
    value = Math.min(max, value);

    input.value = value;
  });
})();
